import { FC, HTMLAttributes } from 'react';
import { styled, keyframes } from '@robocorp/theme';

import astronaut from '~/assets/mark/astronaut.png';

export const float = keyframes`
  0% {
    transform: translateY(-7%) rotate(10deg);
  }
  100% {
    transform: translateY(7%) rotate(-5deg);
  }
`;

const FloatingImage = styled.img`
  max-width: 90px;
  margin-left: 24px;
  animation: ${float} 14s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate;
  transform-origin: center center;
`;

export const FloatingSpaceMark: FC<Omit<HTMLAttributes<HTMLImageElement>, 'src'>> = (props) => (
  <FloatingImage src={astronaut} alt="Mark in space" {...props} />
);
